export default __webpack_public_path__ + "static/media/KathlynLovelace.51b5e561.png";